/**
 * Dev/offline only. Builds a syntactically-shaped fake Norwegian fødselsnummer whose birth date makes
 * the holder `age` years old today, so the offline AI-mock persona can drive age-gated UI (e.g. the
 * investment-allocation downscaling card, which requires `getUserAge() > 57`).
 *
 * This is the inverse of `getBirthDateFromNin` in `getUserAge.ts`, and must stay in sync with its
 * century rules: the birthday is fixed to 1 January so the age is exact regardless of today's month,
 * and the century is encoded via the individual number (000–499 → 1900s; 500–999 with YY ≤ 39 → 2000s).
 * Supported for ages that map to birth years 1900–2039 (i.e. roughly 0–120 today) — the range the
 * spec parser already enforces. NOT a real person's number: the two control digits are placeholders,
 * which `getBirthDateFromNin` does not validate.
 */
export const ninForAge = (age: number): string => {
  const birthYear = new Date().getFullYear() - age;
  const yy = String(birthYear % 100).padStart(2, "0");
  const individualNumber = birthYear >= 2000 ? "500" : "123";
  return `0101${yy}${individualNumber}00`;
};
